import styled from 'styled-components';
import { Box, Paper, Typography, Button } from '@mui/material';

export const FormWrapper = styled(Box)`
  && {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 32px;
  }
`;

export const StyledPaper = styled(Paper)`
  && {
    padding: 32px;
    border-radius: 16px;
  }
`;

export const Title = styled(Typography)`
  && {
    font-weight: bold;
    margin-bottom: 16px;
  }
`;

export const SubmitButton = styled(Button)`
  && {
    margin-top: 24px;
    padding: 12px;
    text-transform: none;
    font-weight: 600;
  }
`;
